import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Home, ArrowLeft, Sparkles } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-sky-50 flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="fixed top-0 right-0 w-96 h-96 bg-sky-300/15 rounded-full blur-3xl pointer-events-none" />
      <div className="fixed bottom-0 left-0 w-72 h-72 bg-indigo-300/10 rounded-full blur-3xl pointer-events-none" />
      
      <div className="text-center max-w-md relative z-10">
        <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-sky-400 to-indigo-400 flex items-center justify-center shadow-lg">
          <Sparkles className="w-10 h-10 text-white" strokeWidth={1.5} />
        </div>
        
        <h1 className="text-7xl font-light text-sky-300 mb-2" style={{ fontFamily: 'Outfit' }}>
          404
        </h1>
        <h2 className="text-2xl font-light text-sky-900 mb-3" style={{ fontFamily: 'Outfit' }}>
          Page Not Found
        </h2>
        <p className="text-slate-500 mb-8">
          Looks like this page took a rest day. Let's get you back on track.
        </p>
        
        <div className="flex gap-3 justify-center">
          <Button onClick={() => navigate(-1)} variant="outline" className="gap-2" data-testid="go-back-btn">
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          <Button onClick={() => navigate('/dashboard')} className="glow-button gap-2" data-testid="go-home-btn">
            <Home className="w-4 h-4" />
            Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
